import styles from "./index.module.scss";

const PageHeader = ({ title = "Network Access" }) => {
  return (
    <header className={styles.header}>
      <div className={styles.headerContent}>
        <h1 className={styles.title}>{title}</h1>
      </div>
    </header>
  );
};

export default PageHeader;

